import { memberApiV2 } from '@lib/api';
import { IClinicalDataCount } from 'types/clinical-data.types';

export function getClinicalDataCounts(providerId: string, clientId: string) {
  return memberApiV2.request<{ data: IClinicalDataCount }>(
    '/management/private/client/clinical-data',
    {
      method: 'GET',
      params: { clientId },
      headers: { 'provider-id': providerId },
    },
  );
}
